import { Highlight } from "@tiptap/extension-highlight";

const DEFAULT_HIGHLIGHT_COLOR = "#fff4c6";

const CustomHighlight = Highlight.extend({
  addAttributes() {
    return {
      color: {
        default: DEFAULT_HIGHLIGHT_COLOR,
        parseHTML: (element) =>
          element.getAttribute("data-color") ||
          element.style.backgroundColor ||
          DEFAULT_HIGHLIGHT_COLOR,
        renderHTML: (attributes) => {
          const color = attributes.color || DEFAULT_HIGHLIGHT_COLOR;
          return {
            "data-color": color,
            style: `background-color: ${color}; color: inherit`,
          };
        },
      },
    };
  },
});

export default CustomHighlight;
